import { Image } from 'react-bootstrap';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import BarChartIcon from '@mui/icons-material/BarChart';


const Feature1 = () => {
    return (
        <section>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-12 order-lg-1 mb-8 mb-lg-0">
                        <Image src={require('../../assets/images/about/08.png')} alt="testimage" fluid />
                    </div>
                    <div className="col-lg-7 col-12">
                        <div className="mb-8">
                            <span className="badge badge-primary-soft p-2">
                                <i className="la la-cubes ic-3x rotation" />
                            </span>
                            <h2 className="mt-3 mb-0">Aplicație Mobilă Avansată</h2>
                            <p>Explorați versatilitatea aplicației mobile care facilitează procesul de creare a rapoartelor, oferindu-vă un instrument puternic pentru generare și gestionare eficientă.</p>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="d-flex align-items-start">
                                    <div>
                                        <div className="f-icon-shape-sm text-white bg-primary rounded-circle shadow-primary me-3"> <i className="la la-desktop ic-2x"></i>
                                        </div>
                                    </div>
                                    <div>
                                        <h5>Interfață Prietenoasă și Intuitivă</h5>
                                        <p className="mb-0">Bucurați-vă de o experiență mobilă fluentă și prietenoasă, proiectată pentru a vă ghida pas cu pas în procesul de creare a rapoartelor.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 mt-6 mt-md-0">
                                <div className="d-flex align-items-start">
                                    <div>
                                        <div className="f-icon-shape-sm text-white bg-dark rounded-circle shadow-primary me-3"> <BackupTableIcon/>
                                        </div>
                                    </div>
                                    <div>
                                        <h5>Generare Rapoarte Rapidă</h5>
                                        <p className="mb-0">Realizați rapoarte cu ușurință direct de pe teren, economisind timp prețios. Interfața simplificată vă permite să completați și să trimiteți rapoartele în doar câteva click-uri.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 mt-6">
                                <div className="d-flex align-items-start">
                                    <div>
                                        <div className="f-icon-shape-sm text-white bg-white rounded-circle shadow-primary me-3"> <i className="la la-download ic-2x text-primary"></i>
                                        </div>
                                    </div>
                                    <div>
                                        <h5>Acces la Statistici în Timp Real</h5>
                                        <p className="mb-0">Fie că sunteți în birou sau pe teren, accesați statistici în timp real pentru o analiză imediată și pentru a lua decizii informate în timp util.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 mt-6">
                                <div className="d-flex align-items-start">
                                    <div>
                                        <div className="f-icon-shape-sm text-white bg-orange rounded-circle shadow-primary me-3"> <NotificationsActiveIcon/>
                                        </div>
                                    </div>
                                    <div>
                                        <h5>Notificări Personalizate</h5>
                                        <p className="mb-0">Stabiliți-vă propriile notificări pentru a fi alertat în timp real cu privire la evenimente cheie. Rămâneți conectat și reacționați rapid la nevoile în schimbare ale procesului de generare a rapoartelor.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Feature1;
